import { filter, set } from 'lodash';
import { sentenceCase } from 'change-case';
import { useState, useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
// material
import {
  Card,
  Table,
  Stack,
  Avatar,
  Button,
  Checkbox,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from '@mui/material';
import IconButton from '@mui/material/IconButton';  
import axios from 'axios';
// components
import Page from '../components/Page';
import Label from '../components/Label';
import Scrollbar from '../components/Scrollbar';
import Iconify from '../components/Iconify';
import SearchNotFound from '../components/SearchNotFound';
import { DqmListHead, DqmListToolbar,  DqmMoreMenu} from '../sections/reports';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'dqmTitle', label: 'DQM Title', alignRight: false },
  { id: 'dqmDescription', label: 'DQM Description', alignRight: false },
  { id: 'title', label: 'Title', alignRight: false },
  { id: 'year', label: 'Year', alignRight: false }, 
  { id: 'material', label: 'DMaterial', alignRight: false },
  { id: 'active', label: 'Active', alignRight: false },
  { id: 'action', label: 'Action', alignRight: false },
];

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query, roleFilter) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });

  let filteredArray = stabilizedThis.map((el) => el[0]);

  // Apply text query filter
  if (query) {
    filteredArray = filteredArray.filter((dqm) => {
     if(dqm.title.toLowerCase().includes(query.toLowerCase())){
       return true;
      }
      if(String(dqm.year).toLowerCase().includes(query.toLowerCase())){
        return true;
      }
      if(dqm.material.toLowerCase().includes(query.toLowerCase())){
        return true;
      } 
      if(dqm.active.toLowerCase().includes(query.toLowerCase())){
        return true;
      }
      return false;
    });
  }
  

  // Apply role filter
  if (roleFilter) {
    filteredArray = filteredArray.filter((dqm) =>
      dqm.role.toLowerCase() === roleFilter.toLowerCase()
    );
  }

  return filteredArray;
}

export default function Dqm() {
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('desc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('year'); // Default sort by email
  const [filterName, setFilterName] = useState('');
  const [roleFilter, setRoleFilter] = useState(''); // State for role filter
  const [rowsPerPage, setRowsPerPage] = useState(5);

  // State for dqm
  const [dqm, setDqm] = useState([]);
  const [editingdqmId, setEditingDqmId] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [title, setTitle] = useState('');
  const [year, setYear] = useState('');
  const [material, setMaterial] = useState('');
  const [active, setActive] = useState('');
  const [selecteddqm, setSelectedDqm] = useState(null);
  const [viewModalOpen, setViewModalOpen] = useState(false);
  const [dqmTitle, setDqmTitle] = useState('');
  const [dqmDescription, setDqmDescription] = useState('');



  // Fetch dqm from the server on component mount
  useEffect(() => {
    fetchdqm();
  }, []);

  // Fetch dqm from the server
  const fetchdqm = async () => {
    try {
      const response = await axios.get('https://cpccbe.org/api/dqm/getalldqm'); 
      setDqm(response.data);
    } catch (error) {
      console.error("Error fetching dqm:", error);
    }
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = dqm.map((n) => n.email); // Use email as unique identifier
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, email) => {
    const selectedIndex = selected.indexOf(email);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, email);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  // Handle opening and closing of modal for editing dqm
  const handleOpenModal = (dqmId) => {
    if (dqmId) {

      const dqmtoEdit = dqm.find(dqm=> dqm._id === dqmId);
      if(dqmtoEdit){
        setDqmTitle(dqmtoEdit.dqmtitle);
        setDqmDescription(dqmtoEdit.dqmdescription);
        setTitle(dqmtoEdit.title);
        setYear(dqmtoEdit.year);
        setMaterial(dqmtoEdit.material);
        setActive(dqmtoEdit.active);
        setEditingDqmId(dqmId);
      }
    } else {
      setDqmTitle('');
      setDqmDescription('');
      setTitle('');
      setYear('');
      setMaterial('')
      setActive('');
      setEditingDqmId(null);
    }
    setOpenModal(true);

  };


  const handleCloseModal = () => {
    setOpenModal(false);
    setDqmTitle('');
    setDqmDescription('');
    setTitle('');
    setYear('');
    setMaterial('')
    setActive('');
    setEditingDqmId(null);

  };



  // Handle adding a new dqm
  const handleAdddqm = async () => {
    try {
      const response = await axios.post('https://cpccbe.org/api/dqm/createdqm',{ dqmTitle, dqmDescription, title,year,material,active }); // Adjust based on your actual data structure

      fetchdqm(); // Refresh dqm list after adding
      handleCloseModal(); // Close modal after adding
    } catch (error) {
      console.error("Error adding dqm:", error);
    }
  };

  // Handle updating a dqm
  const handleUpdatedqm = async () => {
    try {
      await axios.patch(`https://cpccbe.org/api/dqm/updatedqm/${editingdqmId}`, { dqmTitle, dqmDescription, title,year,material,active }); // Adjust endpoint as necessary
      fetchdqm(); // Refresh dqm list after updating
      handleCloseModal(); // Close modal after updating
    } catch (error) {
      console.error("Error updating dqm:", error);
    }
  };

  // Handle deleting a dqm
  const handleDeletedqm = async (dqmId) => {
    if (window.confirm("Are you sure you want to delete this dqm?")) {
      try {
        await axios.delete(`https://cpccbe.org/api/dqm/deletedqm/${dqmId}`); // Adjust endpoint as necessary
        fetchdqm(); // Refresh dqm list after deletion
      } catch (error) {
        console.error("Error deleting dqm:", error);
      }
    }
  };

  const handleViewdqm = (dqm) => {
    // Open a modal or set state to display dqm details
    setSelectedDqm(dqm); // Assuming you have state to hold selected history data
    setViewModalOpen(true); // Open the modal for viewing history details
  };




  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - dqm.length) : 0;

  // Apply sorting and filtering
  const filtereddqm = applySortFilter(dqm, getComparator(order, orderBy), filterName, roleFilter);


  const isdqmNotFound = filtereddqm.length === 0;
  
  return (
    <Page title="dqm">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            DQM
          </Typography>
          <Button variant="contained" onClick={handleOpenModal} startIcon={<Iconify icon="eva:plus-fill" />}>
            New DQM
          </Button>
        </Stack>

        <Card>
          <DqmListToolbar
            numSelected={selected.length}
            filterName={filterName}
            onFilterName={handleFilterByName}
            roleFilter={roleFilter}
            onRoleFilterChange={(e) => setRoleFilter(e.target.value)}
          />


          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <DqmListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={dqm.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>
                  {filtereddqm.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                    const { _id, email, role } = row; // Adjust based on your actual data structure
                    const isItemSelected = selected.indexOf(email) !== -1;

                    return (
                      <TableRow
                        hover
                        key={_id}
                        tabIndex={-1}
                        role="checkbox"
                        selected={isItemSelected}
                        aria-checked={isItemSelected}
                      >
<TableCell align="left">
  <IconButton onClick={() => handleViewdqm(row)} aria-label="view dqm">
    <Iconify icon="eva:eye-fill" />
  </IconButton>
</TableCell>
                       
                        <TableCell align="left">{row.dqmtitle}</TableCell>
                        <TableCell align="left">{row.dqmdescription}</TableCell>
                        <TableCell align="left">{row.title}</TableCell>
                        <TableCell align="left">{row.year}</TableCell>
                        <TableCell align="left">{row.material}</TableCell>
                        <TableCell align="left">{row.active}</TableCell>
                        <TableCell align="left">
                          <DqmMoreMenu
                            onEdit={() => handleOpenModal(row._id)}
                            onDelete={() => handleDeletedqm(row._id)}
                          />
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>

                {isdqmNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <SearchNotFound searchQuery={filterName} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={dqm.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>

        {/* Modal for Editing dqm */}
        <Dialog open={openModal} onClose={handleCloseModal}>
          <DialogTitle>{editingdqmId ? "Edit dqm" : "Add New dqm"}</DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              margin="dense"
              id="dqmtitle"
              label="DQM Title"
              type="text"
              fullWidth
              value={dqmTitle}
              onChange={(e) => setDqmTitle(e.target.value)}
            />
            <TextField
              margin="dense"
              id="dqmdescription"
              label="DQM Description"
              type="text"
              fullWidth
              value={dqmDescription}
              onChange={(e) => setDqmDescription(e.target.value)}
            />
            <TextField
              autoFocus
              margin="dense"
              id="title"
              label="Title"
              type="text"
              fullWidth
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
            <TextField
              margin="dense"
              id="year"
              label="Year"
              type="text"
              fullWidth
              value={year}
              onChange={(e) => setYear(e.target.value)}
            />
            <TextField
              margin="dense"
              id="material"
              label="Material"
              type="text"
              fullWidth
              value={material}
              onChange={(e) => setMaterial(e.target.value)}
            />
           <FormControl fullWidth margin='dense'>
            <InputLabel id="active">Active</InputLabel>
            <Select
              labelId="active"
              id="active"
              value={active}
              onChange={(e) => setActive(e.target.value)}
            >
              <MenuItem value="active">Active</MenuItem>
              <MenuItem value="inactive">Inactive</MenuItem>
            </Select>
          </FormControl>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseModal}>Cancel</Button>
            {editingdqmId ? (
              <Button onClick={handleUpdatedqm}>Update DQM</Button>
            ) : (
              <Button onClick={handleAdddqm}>Add DQM</Button>
            )}
          </DialogActions>
        </Dialog>

        <Dialog open={viewModalOpen} onClose={() => setViewModalOpen(false)}>
          <DialogTitle>DQM Details</DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              margin="dense"
              id="dqmTitle"
              label="DQM Title"
              type="text"
              fullWidth
              value={selecteddqm?.dqmtitle}
              disabled  
              />
            <TextField
              margin="dense"
              id="dqmDescription"
              label="DQM Description"
              type="text"
              fullWidth
              value={selecteddqm?.dqmdescription}
              disabled
              />
            <TextField
              margin="dense"
              id="title"
              label="Title"
              type="text"
              fullWidth
              value={selecteddqm?.title}
              disabled
              />
            <TextField
              margin="dense"
              id="year"
              label="Year"
              type="text"
              fullWidth
              value={selecteddqm?.year}
              disabled
              />
            <TextField
              margin="dense"
              id="material"
              label="Material"
              type="text"
              fullWidth
              value={selecteddqm?.material}
              disabled
              />
            <TextField
              margin="dense"
              id="active"
              label="Active"
              type="text"
              fullWidth
              value={selecteddqm?.active}
              disabled
              />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setViewModalOpen(false)}>Close</Button>
          </DialogActions>
        </Dialog>


      </Container>
    </Page>
  );
}
